import React, { Component } from 'react';

import DropdownMenuContext from './DropdownMenuContext';
import InlineDialog from './InlineDialog';

const MENU_PANEL_STYLE = {
    background: '#ffffff',
    border: '1px solid rgba(69, 81, 102, 0.25)',
    borderRadius: '10px',
    boxShadow: '0 4px 8px -2px rgba(9, 30, 66, 0.25), 0 0 1px rgba(9, 30, 66, 0.31)',
    minWidth: '180px',
    overflow: 'hidden',
    padding: '4px 0'
};

const TRIGGER_STYLE = {
    alignItems: 'center',
    background: 'transparent',
    border: 0,
    color: 'inherit',
    cursor: 'pointer',
    display: 'inline-flex',
    justifyContent: 'flex-start',
    padding: 0,
    textAlign: 'inherit'
};

class DropdownMenuBase extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isOpen: false
        };

        this._close = this._close.bind(this);
        this._onToggle = this._onToggle.bind(this);
    }

    _isControlled() {
        return typeof this.props.isOpen === 'boolean';
    }

    _getIsOpen() {
        return this._isControlled() ? this.props.isOpen : this.state.isOpen;
    }

    _setOpen(isOpen, event) {
        if (!this._isControlled()) {
            this.setState({ isOpen });
        }

        this.props.onOpenChange?.({ event,
            isOpen });
    }

    _onToggle(event) {
        event?.stopPropagation?.();
        this._setOpen(!this._getIsOpen(), event);
    }

    _close(event) {
        this._setOpen(false, event);
        this.props.onClose?.({ event,
            isOpen: false });
    }

    _renderTrigger() {
        const {
            shouldFitContainer,
            trigger,

            // shouldFitContainer is a styling hint consumed below, not a real
            // DOM/button attribute -- pull it out before spreading the rest
            // of triggerButtonProps onto the actual <button> element, or it
            // leaks straight through and React warns about an unrecognized
            // DOM prop.
            triggerButtonProps: {
                shouldFitContainer: triggerShouldFitContainer,
                ...restTriggerButtonProps
            } = {},
            triggerType = 'button'
        } = this.props;

        return (
            <button
                { ...restTriggerButtonProps }
                className = { `dropdown-menu-trigger ${restTriggerButtonProps.className || ''}`.trim() }
                onClick = { this._onToggle }
                style = {{
                    ...TRIGGER_STYLE,
                    ...shouldFitContainer || triggerShouldFitContainer ? { width: '100%' } : null,
                    ...restTriggerButtonProps.style || null
                }}
                type = { triggerType }>
                {trigger}
            </button>
        );
    }

    render() {
        const { children, placement = 'bottom-start' } = this.props;

        return (
            <InlineDialog
                content = {
                    <DropdownMenuContext.Provider value = {{ close: this._close }}>
                        <div
                            className = { `overflow-menu dropdown-menu-panel ${this.props.className || ''}`.trim() }
                            style = { MENU_PANEL_STYLE }>
                            {children}
                        </div>
                    </DropdownMenuContext.Provider>
                }
                isOpen = { this._getIsOpen() }
                onClose = { ({ event }) => this._close(event) }
                placement = { placement }>
                {this._renderTrigger()}
            </InlineDialog>
        );
    }
}

export class DropdownMenuStateless extends DropdownMenuBase {}

export default class DropdownMenu extends DropdownMenuBase {}

export { default as DropdownItem } from './DropdownItem';
export { default as DropdownItemGroup } from './DropdownItemGroup';
